import { render, staticRenderFns } from "./TranshipmentEvaluation.vue?vue&type=template&id=e7023f06&scoped=true"
import script from "./TranshipmentEvaluation.vue?vue&type=script&lang=js"
export * from "./TranshipmentEvaluation.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentEvaluation.vue?vue&type=style&index=0&id=e7023f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7023f06",
  null
  
)

export default component.exports